import { FaArrowRight, FaCheckCircle, FaGift, FaLock } from "react-icons/fa";
import { getDiscountPercentage, getFinalPrice } from "../utils/pricing";
import DiscountRibbon from "./DiscountRibbon";
import PriceDisplay from "./PriceDisplay";
import ScrollingCourseTitle from "./ScrollingCourseTitle";

export default function CourseCard({ course, currency = "EGP", isDarkMode = false, owned = Boolean(course.purchased), busy = false, onOpen, onPurchase }) {
  const free = getFinalPrice(course) === 0;
  const discounted = !owned && !free && getDiscountPercentage(course) > 0;

  return (
    <article
      onClick={owned ? onOpen : undefined}
      className={`group relative flex h-full min-w-0 flex-col overflow-hidden rounded-2xl border shadow-sm transition duration-300 hover:-translate-y-1 hover:shadow-xl motion-reduce:transform-none motion-reduce:transition-none ${
        isDarkMode ? "border-[var(--study-border)] bg-[var(--study-surface)] shadow-black/10" : "border-slate-200 bg-white shadow-slate-200/60"
      } ${owned ? "cursor-pointer" : ""}`}
    >
      <div className="relative aspect-[1.58] shrink-0 overflow-hidden bg-slate-100">
        <img
          src={course.courseImageUrl || course.imageUrl || "/default-course.jpg"}
          alt={course.name}
          loading="lazy"
          onError={(event) => {
            event.currentTarget.onerror = null;
            if (!event.currentTarget.src.endsWith("/default-course.jpg")) event.currentTarget.src = "/default-course.jpg";
          }}
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.035] motion-reduce:transform-none"
        />
        {!owned && <DiscountRibbon item={course} />}
        {owned && (
          <span className="absolute left-3 top-3 inline-flex items-center gap-1.5 rounded-full border border-white/30 bg-emerald-700/95 px-2.5 py-1 text-[11px] font-semibold text-white shadow-sm backdrop-blur-sm">
            <FaCheckCircle aria-hidden="true" /> Unlocked
          </span>
        )}
      </div>
      <div className="flex flex-1 flex-col gap-4 p-5">
        <ScrollingCourseTitle
          as="h3"
          title={course.name}
          className={`min-w-0 text-[17px] font-bold leading-snug ${isDarkMode ? "text-[var(--study-text)]" : "text-slate-900"}`}
        />
        <div className="flex min-h-[48px] items-end">
          {owned ? (
            <p className={`text-sm ${isDarkMode ? "text-[var(--study-muted)]" : "text-slate-500"}`}>Ready when you are.</p>
          ) : (
            <PriceDisplay item={course} currency={currency} layout="course" />
          )}
        </div>
        <button
          type="button"
          disabled={busy}
          onClick={(event) => {
            event.stopPropagation();
            if (owned) onOpen?.();
            else onPurchase?.();
          }}
          className={`mt-auto inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-xl px-4 py-3 text-sm font-bold transition duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-2 disabled:cursor-wait disabled:opacity-60 motion-reduce:transition-none ${
            owned ? isDarkMode ? "bg-red-700 text-white hover:bg-red-800" : "bg-blue-600 text-white hover:bg-blue-700"
              : free ? "bg-amber-300 text-amber-950 hover:bg-amber-400"
                : discounted ? "bg-[#ed1747] text-white hover:bg-[#d50f3c] hover:shadow-md hover:shadow-rose-500/20"
                  : isDarkMode ? "bg-red-700 text-white hover:bg-red-800" : "bg-[#06315B] text-white hover:bg-[#0b477f]"
          }`}
        >
          {owned ? <FaArrowRight aria-hidden="true" /> : free ? <FaGift aria-hidden="true" /> : <FaLock aria-hidden="true" />}
          {busy ? "Please wait…" : owned ? "Open Course" : free ? "Claim Course" : "BUY"}
        </button>
      </div>
    </article>
  );
}
